import { dispatch } from 'store';
import { openSnackbar } from 'store/reducers/snackbar';

export default function useErrorSnackbar() {
  // Allow either a standard Error object or an object with just a message property
  const errorSnackbar = (error: Error | { message: string }) => {
    console.error(error);
    let trimmedMessage = error.message;
    if (error.message.length > 80) {
      trimmedMessage = `${error.message.substring(0, 77)}...`;
    }
    dispatch(
      openSnackbar({
        open: true,
        message: trimmedMessage,
        variant: 'error',
        alert: {
          color: 'error'
        }
      })
    );
  };

  return errorSnackbar;
}
